<template>
  <a href="/careering" @click.prevent="transitionTo('/careering')">Roles</a>
</template>

<script>
export default {
  name: "FooterToRoles",
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    transitionTo(path) {
      this.$router.push(path);
    },
  },
  mounted() {},
};
</script>

<style>
</style>
